export default {"src":"/_next/static/media/0xaf5191b0de278c7286d6c7cc6ab6bb8a73ba2cd6.03f06fcc.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};